import { render, staticRenderFns } from "./RandomCode.vue?vue&type=template&id=985ce836"
import script from "./RandomCode.vue?vue&type=script&lang=js"
export * from "./RandomCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports